import { Outlet } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { Footer, LanguageSelect, StaffBrand } from './chrome'

/** The pages before the panel: Eklevo's brand, the language and one card. */
export function PublicFrame({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <StaffBrand />
          <LanguageSelect />
        </div>
      </header>
      <main className="mx-auto w-full max-w-md flex-1 px-4 py-12 sm:py-20">{children}</main>
      <Footer />
    </div>
  )
}

/** The sign-in and the passkey step. */
export function PublicLayout() {
  return (
    <PublicFrame>
      <Outlet />
    </PublicFrame>
  )
}
